import { View } from '@lernetz/ts-lib';

import { ScoreQuiz } from './ScoreQuiz';
import { Slide } from './Slide';

import template from './ScoreQuizEvaluation.html';

export class ScoreQuizEvaluation extends Slide {

    public quiz: ScoreQuiz;
    
    public constructor() {
        super( {
            hasInput: true,
            evaluated: true,
        } );
    }
}

export class ScoreQuizEvaluationView extends View<ScoreQuizEvaluation> {

    public constructor() {
        super( { template } );
    }
}
